import { useHealth } from '@features/status/hooks/useHealth';

export interface RegistrationStatus {
  isRegistered: boolean;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useRegistrationStatus(): RegistrationStatus {
  const { data, isLoading, isError, refetch } = useHealth();

  const vessel = data?.vessel ?? null;
  const isRegistered =
    !isLoading &&
    !isError &&
    vessel !== null &&
    vessel.vesselId.length > 0 &&
    vessel.deviceId.length > 0;

  return {
    isRegistered,
    isLoading,
    isError,
    refetch,
  };
}
